import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

/**
 * Génère un lien temporaire vers une photo d'avis.
 * Le chemin doit correspondre à un avis publié — impossible de deviner
 * le chemin d'une photo qui n'est pas rattachée à un avis visible.
 */
export const getReviewPhotoUrl = createServerFn({ method: "GET" })
  .inputValidator((data) => z.object({ path: z.string().min(1).max(300) }).parse(data))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");

    const { data: review, error } = await supabaseAdmin
      .from("product_reviews")
      .select("id")
      .eq("photo_url", data.path)
      .eq("status", "published")
      .limit(1)
      .maybeSingle();
    if (error) throw error;
    if (!review) return { url: null as string | null };

    const { data: signed, error: signError } = await supabaseAdmin.storage
      .from("review-photos")
      .createSignedUrl(data.path, 60 * 60);
    if (signError) throw signError;

    return { url: signed.signedUrl as string | null };
  });
